import _ from 'lodash-extended';
import $ from 'jquery';
import app from 'app';

export default class TimelineTranslateController {
  /**
   * Translate textual effects in timeline visual tracks
   *
   * @param translations
   * @param assets
   * @returns {[Object]} tracks that had been translated
   */
  static translate({ translations, assets }) {
    const rv = [];

    _.each(assets, (track) => {
      if (!_.isEmpty(track.agd) && !_.isEmpty(track.agd.textOverlays)) {
        TimelineTranslateController.eachTrack({
          track,
          translations,
        });

        rv.push(track);
      }
    });

    return rv;
  }

  static eachTrack({ track, translations }) {
    _.each(track.agd.textOverlays, (textOverlay) => {
      TimelineTranslateController.eachTextOverlay({
        textOverlay,
        translations,
      });
    });
  }

  static eachTextOverlay({ textOverlay, translations }) {
    let translation;
    const translationObject = _.find(translations, { guid: textOverlay.id });
    if (translationObject) {
      translation = translationObject.translatedText;
    }
    const $wrapperEl = $('<div class="wt-text-overlay to-editing"></div>');
    const $editorEl = $(
      '<div class="wt-text-overlay-editor tokenizer-root"></div>'
    );
    $editorEl.html(translation);
    $wrapperEl.append($editorEl);
    const style = TimelineTranslateController.wrapperStyleObject(textOverlay);
    $wrapperEl.css(style);
    const editorStyle =
      TimelineTranslateController.editorStyleObject(textOverlay);
    $editorEl.css(editorStyle);
    const tokensAndStyle = app.namespace.Util.tokenizeHtml($wrapperEl);

    textOverlay.paragraphs = tokensAndStyle.paragraphs;
    textOverlay.html = translation;
  }

  static editorStyleObject(tempTo) {
    return {
      padding: tempTo.padding,
    };
  }

  static wrapperStyleObject(tempTo) {
    const backgroundType = tempTo.bgGradient
      ? 'background-image'
      : 'background';

    const style = {
      zIndex: tempTo.zIndex,
      textShadow: TimelineTranslateController.getTextShadowStr(tempTo),
      [backgroundType]: TimelineTranslateController.getBackgroundColor(tempTo),
      minHeight: app.sfp(tempTo.height * app.ASSET_EDITOR_HEIGHT) + 'px',
      width: app.sfp(tempTo.width * app.ASSET_EDITOR_WIDTH) + 'px',
      left: app.sfp(tempTo.offsetX * app.ASSET_EDITOR_WIDTH) + 'px',
      top: app.sfp(tempTo.offsetY * app.ASSET_EDITOR_HEIGHT) + 'px',
      lineHeight: tempTo.lineHeight,
      fontSize: app.sfp(tempTo.fontSize, 10) + 'px',
      transform: 'rotate(' + tempTo.rotation + 'rad)',
    };

    if (tempTo.bgGradient) {
      style.borderImage =
        TimelineTranslateController.getBackgroundColor(tempTo) + ' 1';
    }

    return style;
  }

  static getTextShadowStr(tempTo) {
    // if textShadow is none (disable), or for backwards compatibility
    // if there's no shadowOffsetX and shadowOffsetY, return original textShadow.
    if (
      tempTo.textShadow === 'none' ||
      (!tempTo.shadowOffsetX && !tempTo.shadowOffsetY)
    ) {
      return tempTo.textShadow;
    }

    // construct textShadow css from props
    const rgba = tempTo.textShadow.match(/.+\)/)[0];
    const xPx = app.sfp(tempTo.shadowOffsetX * app.ASSET_EDITOR_WIDTH) + 'px';
    const yPx = app.sfp(tempTo.shadowOffsetY * app.ASSET_EDITOR_HEIGHT) + 'px';
    // the last value in the array is the blur
    const blur = tempTo.textShadow.match(/\S+/g).slice(-1)[0];

    return `${rgba} ${xPx} ${yPx} ${blur}`;
  }

  static getBackgroundColor(tempTO) {
    if (tempTO.bgColor) {
      return tempTO.bgColor;
    } else if (tempTO.bgGradient) {
      return app.namespace.Util.gradientModelToCss(tempTO.bgGradient);
    }
  }
}
